export default __webpack_public_path__ + "static/media/icn-nca.776734db.svg";